import { defineComponent as _defineComponent } from 'vue'
import HeaderCustomer from "@/components/HeaderCustomer.vue";
  import { onMounted, ref } from "vue";
  import router from "../../router/index";
  import store from "@/store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EOIDraftConfirmation',
  setup(__props, { expose: __expose }) {
  __expose();

  const estateId = ref(router.currentRoute.value.params.estateId);
  const estate = ref({});

  onMounted(() => {
    store.dispatch("estate/getEstate", estateId.value).then((res) => {
      estate.value = res.data;
    });
  });

  function toDashboard() {
    router.push("/customer/lots");
  }

const __returned__ = { estateId, estate, toDashboard, HeaderCustomer, onMounted, ref, get router() { return router }, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})